/* ── Identifiant de fiche d'une ligne ──────────────────────────────────────── */
// La liste unifiée préfixe « inv-<uuid> » les postes vus seulement par l'inventaire.
// La fiche les ouvre par l'UUID nu (repli « inventaire seul » du serveur, le même que
// depuis un ticket) ; les postes ESET s'ouvrent par leur id tel quel.
// Mesure prod 25/09/2026 : 479 postes, 476 ESET, 3 inventaire seul — tous ouvrables.
export function ficheId(d) {
  const id = String(d?.id || '');
  if (!id) return null;
  return id.startsWith('inv-') ? id.slice(4) : id;
}
